import { PayloadAction } from "@reduxjs/toolkit";
import { put, takeLatest, call, all } from "redux-saga/effects";

import { commonMessages, ILocale } from "infrastructure/localization";
import { notification } from "infrastructure/notification";
import { IPickerSearchCriterion, applyPickerFilter } from "ui/shared/helpers/plex-components";

import { appLanguageSwitchActions } from "./AppLanguageSwitch.actions";
import { getLocales } from "./AppLanguageSwitch.api";

function* loadSupportedLocalesExecute() {
  try {
    const locales: ILocale[] = yield call(getLocales);

    yield put(appLanguageSwitchActions.loadSupportedLocalesCompleted(locales));
  } catch (error) {
    yield put(appLanguageSwitchActions.loadSupportedLocalesFailed(notification.error(error).useMessageId(commonMessages.error("loadLocalesFailed"))));
  }
}

function* loadSearchedLocalesExecute({ payload }: PayloadAction<IPickerSearchCriterion<ILocale>>) {
  try {
    let locales: ILocale[] = yield call(getLocales, payload.query.query);
    locales = applyPickerFilter(locales, payload, row => row.name);
    applyPickerFilter(locales, payload, row => row.localeIdentifier);

    yield put(appLanguageSwitchActions.loadSearchedLocalesCompleted(locales));
  } catch (error) {
    yield put(appLanguageSwitchActions.loadSearchedLocalesFailed(notification.error(error).useMessageId(commonMessages.error("loadSearchedLocales"))));
  }
}

function* actionWatcher() {
  yield takeLatest(appLanguageSwitchActions.loadSupportedLocales.toString(), loadSupportedLocalesExecute);
  yield takeLatest(appLanguageSwitchActions.loadSearchedLocales.toString(), loadSearchedLocalesExecute);
}

export function* appLanguageSwitchSaga() {
  yield all([actionWatcher()]);
}
